import React, { useEffect, useState } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";

const CounterSection: React.FC = () => {
  const isSmallScreen = useMediaQuery("(max-width:600px)");
  const [count, setCount] = useState<number>(() => {
    const savedCount = localStorage.getItem("currentCount14k_new");
    return savedCount ? parseInt(savedCount, 10) : 14000;
  });

  useEffect(() => {
    const targetCount = 999999;
    const stepDuration = 15; // Faster interval

    const interval = setInterval(() => {
      setCount((prevCount) => {
        if (prevCount >= targetCount) {
          clearInterval(interval);
          return targetCount;
        }
        // Increment by a larger random amount to make it fast
        const nextCount = Math.min(prevCount + Math.floor(Math.random() * 15) + 10, targetCount);
        localStorage.setItem("currentCount14k_new", nextCount.toString());
        return nextCount;
      });
    }, stepDuration);

    return () => clearInterval(interval);
  }, []);

  if (!isSmallScreen) return null;

  return (
    <div style={styles.container}>
      <h2 style={styles.heading}>In The Last 30 Days, We <br /> Have Paid Our Users:</h2>
      <div style={styles.counterWrapper}>
        <div style={styles.currencySymbol}>$</div>
        {count
          .toString()
          .padStart(6, "0")
          .split("")
          .map((digit, index) => (
            <div key={index} style={styles.counterBox}>
              {digit}
            </div>
          ))}
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column" as const,
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center" as const,
    padding: "10px 20px",
    backgroundColor: "#fff",
    borderRadius: "16px",
    color: "#000",
    margin: "0 auto",
    width: "100%",
  },
  heading: {
    fontSize: "22px",
    fontWeight: 700,
    marginBottom: "8px",
    lineHeight: "1.3",
    color: "#1A237E", // Dark Blue for heading
    fontFamily: "General-Sans-bold, sans-serif",
  },
  counterWrapper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "transparent",
    padding: "0",
  },
  currencySymbol: {
    fontSize: "24px",
    fontWeight: 700,
    color: "#FFC107", // Yellow symbol
    marginRight: "4px",
  },
  counterBox: {
    fontSize: "20px",
    fontWeight: 700,
    color: "#fff", // White text
    backgroundColor: "#FFC107", // Yellow background
    borderRadius: "4px",
    width: "30px",
    height: "42px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 3px",
    boxShadow: "none",
  },
};


export default CounterSection;
